import React from 'react';
import { useNavigate } from 'react-router-dom';
import APIsSidebar from './APIsSidebar';
import { useAuth } from '../../../context/AuthContext';
import UserMenu from '../../../components/UserMenu';
import AnnouncementBanner from '../../../components/announcements/AnnouncementBanner';

const APIsLayout = ({ children }) => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  return (
      <div className="flex flex-col lg:flex-row min-h-screen bg-slate-900">
        <APIsSidebar />
        <div className="flex-1 w-full lg:w-auto lg:ml-64">
          <header className="bg-slate-800 border-slate-700 border-b sticky top-0 z-30">
            <div className="px-6 py-4 flex justify-between items-center">
              <h1 className="text-xl font-semibold text-slate-200 ml-12 lg:ml-0 min-w-0 truncate">
                KSP | APIs
            </h1>
            <AnnouncementBanner />
            <div className="flex-shrink-0">
              <UserMenu isDarkMode={true} />
            </div>
          </div>
        </header>
        <main className="p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default APIsLayout;